import { GrupoRequisitos, DadosRequisitosMatricula } from './requisitos';
import { RendimentoFies } from './rendimento-fies';

export class Aluno {
  codigo: number;
  nome: string;
  cpd: string;
  cpf: string;
  periodoAtual: string; // formato YYYY.S
  descSituacaoMatricula: string;
  curso: {
    id: string;
    nome: string;
  };
  campus: {
    id: string;
    nome: string;
  };
  turno: string; // [ M | V | N | I ]
  valorMatricula: number; // valor da matrícula puro
  valorMatriculaDesconto: number; // valor com descontos aplicados
  statusSituacaoMatricula: string;
  situacaoRendAcademico: string;
  matriculado: boolean;
  filterGrupoReqs: GrupoRequisitos[];
  requisitos: DadosRequisitosMatricula
  erroCarregamentoRequisitos: boolean;
  rendimentoFies: RendimentoFies;
  matriculaPaga: boolean;

  get descSituacaoMatriculaAcentoEspaco() {
    if (!this.statusSituacaoMatricula) {
      return undefined;
    }
    //let tmp = ` ${this.statusSituacaoMatricula.toUpperCase().replace(/_/g, ' ')} `;

    const situacoes: Object = {
      "NAO_MATRICULADO" : "CLIQUE AQUI PARA REMATRÍCULA",
      "AGUARDANDO_RENOVACAO_DE_BOLSAS": "AGUARDANDO RENOV. DE BOLSAS",
      "AGUARDANDO_PAGAMENTO": "AGUARDANDO PAGAMENTO",
      "EM_ABANDONO": "EM ABANDONO",
      "MATRICULADO": "MATRICULADO",
    }


    if(situacoes.hasOwnProperty(this.statusSituacaoMatricula)){
      return situacoes[this.statusSituacaoMatricula];
    }
    return ` ${this.statusSituacaoMatricula.toUpperCase().replace(/_/g, ' ')} `;
    
  }

  constructor(args) {
    Object.assign(this, args);
  }

}
